import { render } from "./index.vue?vue&type=template&id=413b666b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=413b666b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-413b666b"

export default script